import styles from "./VariantAttributes.module.scss";

type VariantAttributesUIProps = {
  /**
   * An object or string representing the price of the product.
   */
  price: string | undefined;
  /**
   * A string representing the colour of the product. It can also be null or undefined.
   */
  colour: string | null | undefined;
  /**
   * A string representing the size of the product. It can also be null or undefined.
   */
  size: string | null | undefined;
  /**
   * A string representing the dimensions of the product. It can also be null or undefined.
   */
  dimensions: string | null | undefined;
  /**
   * A boolean representing if the product is sold by the metre
   */
  isPerMetre: boolean;
  /**
   * A boolean representing whether the price should be hidden for single sku products defaults to false
   */
  hidePriceForSingleSku: boolean;
};

export const VariantAttributesUI = ({
  price,
  colour,
  size,
  dimensions,
  isPerMetre,
  hidePriceForSingleSku = false,
}: VariantAttributesUIProps) => {
  return (
    <dl
      data-testid="basket:product:attributes:list"
      className={styles.attributeList}
    >
      {colour && (
        <>
          <dt className={styles.attributeName}>Colour:</dt>
          <dd data-testid="colour:attribute" className={styles.attributeValue}>
            {colour}
          </dd>
        </>
      )}
      {size && (
        <>
          <dt className={styles.attributeName}>Size:</dt>
          <dd data-testid="size:attribute" className={styles.attributeValue}>
            {dimensions ? `${size} ${dimensions}` : size}
          </dd>
        </>
      )}
      {price && !hidePriceForSingleSku && (
        <>
          {isPerMetre && (
            <dt className={styles.attributeEmptyValue}>Total fabric price</dt>
          )}
          <dt className={styles.visuallyHidden}>Price</dt>
          <dd
            data-testid="product:basket:price"
            className={styles.attributeEmptyValue}
          >
            {price}
          </dd>
        </>
      )}
    </dl>
  );
};
